import { useMemo } from "react";
import { useAppSelector } from "../redux";
import { Constants } from "../utils/constants";
import {
  getPermissionPortalKey,
  isAdminPortalRoleType,
} from "../utils/permissions/flattenRolePermissions";

/**
 * True when the logged-in user is HID internal staff (admin portal persona),
 * as opposed to a partner-org user.
 *
 * Prefer roles.type from getUser (HID / Super Admin). Legacy fallbacks when role_type
 * is missing: HID_USER_ROLES name list, or admin sessionPermissionMap after load.
 */
export function useIsHidStaff(): boolean {
  const role = useAppSelector((state) => state.auth.loggedUserDetail?.role);
  const roleType = useAppSelector(
    (state) => state.auth.loggedUserDetail?.role_type
  );
  const roleId = useAppSelector((state) => state.auth.loggedUserDetail?.role_id);
  const sessionPermissionMap = useAppSelector(
    (state) => state.auth.sessionPermissionMap
  );
  const loaded = useAppSelector((state) => state.auth.sessionPermissionsLoaded);

  return useMemo(() => {
    if (!roleId) {
      return Constants.HID_USER_ROLES.includes(role ?? "");
    }
    if (roleType) {
      return isAdminPortalRoleType(roleType);
    }
    if (role) {
      return getPermissionPortalKey(role) === "admin";
    }
    if (!loaded) {
      return false;
    }
    const hasAdminPortalAccess = Object.values(sessionPermissionMap).some(
      (action) => action === "edit" || action === "view"
    );
    return hasAdminPortalAccess;
  }, [role, roleType, roleId, sessionPermissionMap, loaded]);
}
